/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userVerification.internal

import features.userVerification.models.UserProfileModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userVerification.internal.UserAccountVerificationUseCase.Params

internal class UserAccountVerificationUseCase : AsyncUseCase<UserProfileModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val intent: String,
        val token: String,
        val email: String?,
        val phone: String?,
        val countryCode: String?
    )

    private val userAccountVerificationService: UserAccountVerificationService = UserAccountVerificationServiceImpl()

    override suspend fun run(params: Params): Result<UserProfileModel> {
        return userAccountVerificationService.verifyAccount(
            overrideHeaders = params.overrideHeaders,
            intent = params.intent,
            token = params.token,
            email = params.email,
            phone = params.phone,
            countryCode = params.countryCode
        )
    }
}
